import { Injectable } from '@angular/core';
import { Program } from '@generated/tcea/models';
import { Observable } from 'rxjs';

@Injectable()
export abstract class AbstractLoyaltyService {
  abstract getAllPrograms(brandId: string): Observable<Program[]>;
  abstract getProgramById(brandId: string, programId: string): Observable<Program>;
  abstract create(brandId: string, createData: any): Observable<Program>;
  abstract update(brandId: string, programId: string, updateData: Program): Observable<Program>;
}
